module.exports = __webpack_public_path__ + "assets/eb43bba1a04c4c056b8d8435c2ad0269.png";